import { GlobalToken } from 'antd';
import styled from 'styled-components';

interface ContainerProps {
  width: number;
  height: number;
  $mapView: number;
  $isSelectedOnMap: boolean;
  $textColor: string;
  theme: { token: GlobalToken };
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  ${({ $mapView, theme: { token } }) => $mapView === 1 && `margin-top: ${token.marginMD}px;`}
  display: flex;
  flex-direction: column;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${({ $mapView }) => $mapView};
  }

  .top-row {
    width: 98.5%;
    height: 37.5%;
    display: flex;
    justify-content: flex-end;
    ${({ $textColor, theme: { token } }) => $textColor && `margin-top: ${token.marginXL}px;`}
  }

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ $textColor }) => $textColor};
    text-transform: capitalize;
    position: absolute;
    top: 18px;
    left: 35px;
  }

  .connectivity-wrapper {
    width: 40%;
    padding: ${({ theme: { token } }) => token.paddingXXS}px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  header {
    display: flex;
    align-items: center;
    width: 65%;
    padding-left: ${({ theme: { token } }) => token.paddingSM}px;

    .title-wrapper {
      width: 100%;
    }

    .type {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }
  }

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: ${({ theme: { token } }) => token.paddingXXS}px;
    margin-bottom: ${({ theme: { token } }) => token.marginMD}px;

    .package-care-wrapper {
      position: absolute;
      bottom: 20px;
      left: 5px;
      width: 130px;
    }
    .temperature-container {
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;

      .value {
        font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .label {
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }
`;
